<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @close-modal="closeModal"
    modal-alignment="center"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        data-url=""
      >
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="evalTest.file_evaluation">
              <td class="align-middle">
                Designación del equipo evaluador
                <br />
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.type == 'E'">
              <td class="align-middle">Evaluación Documental</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'report_documentary_evaluation')
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.sampling_plan_file">
              <td class="align-middle">Plan de muestreo</td>

              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.type == 'E'">
              <td class="align-middle">Plan de Evaluación</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'evaluation_plan_report')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
            <!-- <tr v-if="evalTest.type == 'E'">
              <td class="align-middle">Plan de Evaluación (Aprobado)</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'accepted_evaluation_plan')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr> -->
            <tr v-if="evalTest.type == 'E'">
              <td class="align-middle">Reuniones de Evaluación</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'attendance_record')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.type == 'E'">
              <td class="align-middle">Cuestionario de Evaluación</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'evaluation_questionnaire')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.type == 'T'">
              <td class="align-middle">Ejecución de la testificación</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'testification_evaluation_questionnaire')
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.type == 'T'">
              <td class="align-middle">Informe de Testificación</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'testification_report')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.other_findings_file">
              <td class="align-middle">
                Otro
                <br />
                <b>Observaciones:</b> {{ evalTest.other_findings }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'other_findings_file')"
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
            <tr>
              <td class="align-middle">
                Informe Técnico de Análisis de Expediente y de Toma de Decisión
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'technical_file_analysis_report')
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "preparation-certificate-annexes-modal",
      modalTitle: "",
      evalTest: {},
    };
  },

  created() {
    this.evalTest = this.$store.state.qualityManagement.evaluation;
  },
  methods: {
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>